import './Pillar.css';
import pillarIllustration from './pillarIllustration.svg'
import React from "react";

function Pillar(props) {
    return (
        <div>
            <p className="pillarInnerText"> {props.title}</p>
            <div className={"pillarGradient pillarGradientTop pillarGradient" + props.glowPercent}></div>
            <div className={"pillarGradient pillarGradientBottom pillarGradient" + props.glowPercent}></div>
            <img className="pillarIllustration" src={pillarIllustration} alt="black outline illustration of a fancy pillar with two swirls at the top and the bottom"></img>
        </div>
    )
}

export default Pillar;